var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar",style:({
    'background-image': _vm.avatar ? 'url(' + require('../assets/img/projects/' + _vm.avatar) + ')' : undefined,
    'background-color': _vm.color
})})
}
var staticRenderFns = []

export { render, staticRenderFns }